import { useState, useEffect, useCallback, useMemo } from 'react';
import { fetchMyOpenTasks } from '../lib/tasks';
import { isTaskOverdue } from '../lib/taskNavigation';

export default function useMyTasks(profileId) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!profileId) {
      setTasks([]);
      return;
    }
    setLoading(true);
    try {
      const rows = await fetchMyOpenTasks(profileId);
      setTasks(rows);
    } catch (e) {
      console.error('[useMyTasks] load failed', e);
      setTasks([]);
    } finally {
      setLoading(false);
    }
  }, [profileId]);

  useEffect(() => { refresh(); }, [refresh]);

  useEffect(() => {
    function onFocus() { refresh(); }
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [refresh]);

  const openCount = tasks.length;
  const overdueCount = useMemo(
    () => tasks.filter(isTaskOverdue).length,
    [tasks]
  );

  return { tasks, loading, openCount, overdueCount, refresh };
}
